import { StyleProp, ViewStyle } from 'react-native';
import { FileList } from '@shared/components/FileList';
import { ImageList } from '@shared/components/ImageList';
import { FileField } from '@shared/data/entity/fields/FileField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

const IMAGE_DIMENSION = 36;

interface Props {
  field: FileField;
  style: StyleProp<ViewStyle>;
}

export function FileCollectionViewField({ field, style }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const { files } = field;

  return (
    <CardCollectionViewFieldContainer style={style}>
      <ImageList
        files={files}
        editable={false}
        maxHeight={IMAGE_DIMENSION}
        maxWidth={IMAGE_DIMENSION}
        maxImages={3}
        style={{ paddingVertical: grid(0.5) }}
        itemStyle={{ borderRadius: grid(0.5) }}
      />
      <FileList files={files} editable={false} maxFiles={1} showFileIcon={false} />
    </CardCollectionViewFieldContainer>
  );
}
